import { client } from '@cockpitai/lib/api'
import type { AccessLogPayload } from './types'

export async function sendAccessLog(data: AccessLogPayload) {
  return client.post('/users/access-logs', data)
}
